import { render } from "./outOfStock.vue?vue&type=template&id=58c0c2de&scoped=true"
import script from "./outOfStock.vue?vue&type=script&lang=js"
export * from "./outOfStock.vue?vue&type=script&lang=js"

import "./outOfStock.vue?vue&type=style&index=0&id=58c0c2de&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58c0c2de"]])

export default __exports__